export const ADD_MESSAGE = 'ADD_MESSAGE';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const CLEAR_SINGLE_FILTER = 'CLEAR_SINGLE_FILTER';
export const INIT_FAIL = 'INIT_FAIL';
export const INIT_FINISHED = 'INIT_FINISHED';
export const INIT_SUCCESS = 'INIT_SUCCESS';
export const SELECT_FILTER_CRUISE_CATEGORY = 'SELECT_FILTER_CRUISE_CATEGORY';
export const SELECT_FILTER_DEPARTURE_MONTH = 'SELECT_FILTER_DEPARTURE_MONTH';
export const SELECT_FILTER_DESTINATION = 'SELECT_FILTER_DESTINATION';
export const SELECT_FILTER_DURATION = 'SELECT_FILTER_DURATION';
export const SELECT_FILTER_NUMBER_OF_DESTINATIONS = 'SELECT_FILTER_NUMBER_OF_DESTINATIONS';
export const SELECT_FILTER_SHIP_RATING = 'SELECT_FILTER_SHIP_RATING';
export const SELECT_FILTER_SHIPPING_COMPANY = 'SELECT_FILTER_SHIPPING_COMPANY';
export const SORT_CRUISE_LIST = 'SORT_CRUISE_LIST';
export const TOGGLE_ERROR_POPUP = 'TOGGLE_ERROR_POPUP';
export const TOGGLE_FILTER_PANEL = 'TOGGLE_FILTER_PANEL';
export const TOGGLE_SORT_PANEL = 'TOGGLE_SORT_PANEL';